import { useEffect, useRef, useState } from 'react'
import type { CommunityContentBlock } from '../types'
import { copyDraft, copyBlocks } from '../lib/community-copy'

type Props = { blocks: CommunityContentBlock[]; onChange: (blocks: CommunityContentBlock[]) => void }

export function CommunityCopyEditor({ blocks, onChange }: Props) {
  const [draft, setDraft] = useState(() => copyDraft(blocks))
  const published = useRef(blocks)
  useEffect(() => {
    if (published.current !== blocks) {
      published.current = blocks
      setDraft(copyDraft(blocks))
    }
  }, [blocks])
  const update = (next: typeof draft) => {
    setDraft(next)
    published.current = copyBlocks(next)
    onChange(published.current)
  }
  const editLink = (index: number, patch: Partial<CommunityContentBlock>) =>
    update({ ...draft, links: draft.links.map((link, i) => i === index ? { ...link, ...patch } : link) })
  return <section className="community-copy-editor">
    <strong>完整文案</strong>
    <textarea aria-label="完整文案" rows={12} value={draft.text} onChange={event => update({ ...draft, text: event.target.value })} />
    <small>直接编辑或粘贴整篇文案。【链接1】代表商品或领券按钮，可整行移动；删除标记即移除按钮。</small>
    <details className="community-link-settings">
      <summary>商品 / 领券链接设置（{draft.links.length}）</summary>
      {draft.links.map((block, index) => <div className="community-copy-link" key={index}>
        <span>【链接{index + 1}】</span>
        <select aria-label={`链接${index + 1}类型`} value={block.type} onChange={event => editLink(index, { type: event.target.value as 'product' | 'coupon' })}><option value="product">商品</option><option value="coupon">领券</option></select>
        <input aria-label={`链接${index + 1}按钮文字`} value={block.text} onChange={event => editLink(index, { text: event.target.value })} />
        <input className="community-copy-url" aria-label={`链接${index + 1}地址`} placeholder="粘贴链接（可选）" value={block.url ?? ''} onChange={event => editLink(index, { url: event.target.value || null })} />
      </div>)}
      <button className="community-add" type="button" onClick={() => update({ text: draft.text + (draft.text ? '\n' : '') + `【链接${draft.links.length + 1}】`, links: [...draft.links, { type: 'product', text: '抢购商品', url: null }] })}>＋添加商品 / 领券</button>
    </details>
  </section>
}
